<template>

	<table class="table">

		<tbody>
			<!-- Coupon -->
			<tr v-for="coupon in coupons" class="table__row">
				<th>{{ coupon.offer_snapshot.title }}</th>
				<td>
					<span>{{ coupon.amount_local.formatted }}</span>
					<b-button variant="light" class="ml-2" @click="handleRemoveCoupon(coupon)">Remove</b-button>
				</td>
			</tr>

			<!-- Shipping -->
			<tr class="table__row">
				<th>Shipping</th>
				<td>
                    <h6 class="my-3">Shipping options will be updated during checkout.</h6>
				</td>
			</tr>

            <!-- Shipping -->
            <tr class="table__row">
                <th>Sales Tax</th>
                <td>
                    <h6 class="my-3">Sales Tax will be updated during checkout.</h6>
                </td>
            </tr>

			<!-- Total -->
			<tr class="table__row">
				<th>Total ({{ currency }})</th>
				<td>
					<h5>
						<strong>{{ subtotal }}</strong>
					</h5>
				</td>
			</tr>

			<!-- Checkout/continue shopping buttons -->
			<tr class="table__row">
				<td colspan="6" class="bottom-buttons">
					<a href="/products" class="btn btn-light mr-2">Continue Shopping</a>
					<router-link to="/checkout" class="btn btn-primary">Proceed to checkout</router-link>
				</td>
			</tr>

		</tbody>
	</table>

</template>

<script>

	export default {
		props: {
			subtotal: String,
			total: String,
			coupons: Array,
			currency: String
		},

		methods: {
			handleRemoveCoupon(coupon) {
				this.$emit('remove-coupon', coupon);
			}
		}
	}

</script>

<style lang="scss" scoped>

	.table {
		background-color: white;
		width: 100%;
		border: 1px solid #dee2e6;
		border-radius: 8px;
		border-collapse: separate;
	}

	.table__row td, th {
		border: none;
		padding: 0.75rem;
		border-bottom: 1px solid #dee2e6;
	}

	.table .table__row:last-child > td {
		border-bottom: none;
	}

	.bottom-buttons {
		text-align: right;
	}

	@media (max-width: 767px) {
		.bottom-buttons {
			padding-left: 0 !important;
			padding-right: 0 !important;
			text-align: center;
		}
	}

</style>
